import { useContext } from 'react';
import Slider from './Slider'; 
import SettingsContext from './SettingsContext';

function Settings(){
    const settingsInfo = useContext(SettingsContext);

    return(
        <div style={{textAlign:"center", marginTop:"30px"}}>
            <label style={{fontSize:"17px"}}>Work time: {settingsInfo.workMinutes}:00</label>
            <div>
            <Slider min={1} max={120} value={settingsInfo.workMinutes} onChange={newValue => settingsInfo.setWorkMinutes(newValue)}/>
            
            </div>
            <label style={{fontSize:"17px"}}>Break time:  {settingsInfo.breakMinutes}:00</label>
            <Slider min={1} max={30} value={settingsInfo.breakMinutes} onChange={newValue => settingsInfo.setBreakMinutes(newValue)}/>
            <label style={{fontSize:"17px"}}>Show quotes:</label>
            <input className='switch' type="checkbox" checked={settingsInfo.showQuotes} onChange={(e) => settingsInfo.setShowQuotes(e.target.checked)}/>        
        </div>
    );
}

export default Settings;